import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute.js"

import AddManageFavorite from "./ManageFavorite/Create.js"
import ManageFavorite from "./ManageFavorite/View.js"

import AddManageKeyword from "./ManageKeyword/Create.js"
import ManageKeyword from "./ManageKeyword/View.js"

import AddSuggestedKeyword from "./SuggestedKeyword/Create.js"
import SuggestedKeyword from "./SuggestedKeyword/View.js"

import AddPopularFavoriteInterest from "./PopularFavoriteInterest/Create.js"
import PopularFavoriteInterest from "./PopularFavoriteInterest/View.js"

import ProtectedRoute from "../RouteProtect.js"

const CarrierCardArray = [
    {
        title: "Manage Favorite",
        path: "manageFavorite",
        auth: "carrier",
    },
    {
        title: "Manage Keyword",
        path: "manageKeyword",
        auth: "carrier",
    },
    {
        title: "Suggested Keyword",
        path: "suggestedKeyword",
        auth: "carrier",
    },
    {
        title: "Popular Favorite Interest",
        path: "popularFavoriteInterest",
        auth: "carrier",
    },
]


const RoutesArray = [
    {
        path: "/",
        element: <CreateCard cardJson={[...CarrierCardArray]} />
    },
    {
        path: "*",
        element: <h1>This is 404</h1>
    },
    {
        path: "manageFavorite/*",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <ManageFavorite />
                </ProtectedRoute>
            )
    },
    {
        path: "manageFavorite/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "manageFavorite/addfavorite",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <AddManageFavorite />
            </ProtectedRoute>
        )
    },
    {
        path: "manageKeyword/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <ManageKeyword />
            </ProtectedRoute>
        )
    },
    {
        path: "manageKeyword/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "manageKeyword/addkeyword",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <AddManageKeyword />
            </ProtectedRoute>
        )
    },
    {
        path: "suggestedKeyword/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <SuggestedKeyword />
            </ProtectedRoute>
        )
    },
    {
        path: "suggestedKeyword/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "suggestedKeyword/addkeyword",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <AddSuggestedKeyword />
            </ProtectedRoute>
        )
    },
    {
        path: "popularFavoriteInterest/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <PopularFavoriteInterest />
            </ProtectedRoute>
        )
    },
    {
        path: "popularFavoriteInterest/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "popularFavoriteInterest/addinterest",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <AddPopularFavoriteInterest />
            </ProtectedRoute>
        )
    },
];


export default function MangeRoutes() {
    return useRoutes(RoutesArray)
};